export default "__VITE_PUBLIC_ASSET__1c11569d__"